import { cva } from 'class-variance-authority';

const avatarOrgLabelBaseStyles = [
  'text-xs',
  'flex',
  'overflow-hidden',
  'text-ellipsis',
  'whitespace-nowrap',
  'block',
  'select-none',
  'truncate'
];

const avatarOrgLabelStylesSAG = cva([
  ...avatarOrgLabelBaseStyles,
  'text-[#000028]',
  'dark:text-white',
]);

const avatarOrgLabelStylesSHS = cva([
  ...avatarOrgLabelBaseStyles,
  'text-[#666666]',
  'dark:text-white',
]);

export { avatarOrgLabelStylesSAG, avatarOrgLabelStylesSHS };
